/**
 * A class that handles click and enter events for elements with the 'fast-links__interactive-js' class.
 */
class FastLinksInteractive {

	/**
	 * Initializes the FastLinksInteractive class.
	 */
	constructor() {

		this.initEvents();

	}

	/**
	 * Initializes click and enter events for elements with the 'fast-links__interactive-js' class.
	 */
	initEvents() {

		const interactiveElements = document.querySelectorAll( '.fast-links__interactive-js' );

		interactiveElements.forEach( element => {

			// Add click event
			element.addEventListener( 'click', ( event ) => this.handleInteraction( event, element ) );

			// Add keyboard 'Enter' event
			element.addEventListener( 'keydown', ( event ) => {

				if ( event.key === 'Enter' || event.keyCode === 13 ) {

					event.preventDefault(); // Prevent default behavior for Enter key
					this.handleInteraction( event, element );

				}

			} );

		} );

	}

	/**
	 * Handles the interaction by simulating a click on the target element and removing focus from the current button.
	 *
	 * @param {Event} event - The original event (click or enter).
	 * @param {HTMLElement} element - The element that triggered the event.
	 */
	handleInteraction( event, element ) {

		const targetId = element.getAttribute( 'data-interactive' );

		if ( targetId ) {

			const targetElement = document.getElementById( targetId );
			if ( targetElement ) {

				targetElement.click(); // Simulate click on the target element
				element.blur(); // Remove focus from the current button

			}

		}

	}

}

export default FastLinksInteractive;
